<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <ng-container *ngIf="!isLoading">
    <div class="c-widget--info c-widget--info--white" [ngClass]="customClass">
      <ul>
        <li class="title" i18n="@@common.basic_information">Basic Information</li>
        <li>
          <p>
            <span class="key"><span i18n="@@common.name">Name</span>:</span>
            <span class="value">
              <gtd-ui-field-default-string-or-empty [data]="data.name"></gtd-ui-field-default-string-or-empty>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="key"><span i18n="@@common.offer">Offer</span>:</span>
            <span class="value">
              <gtd-ui-field-default-link
                [link]="['/app/traffic-control/offers', data?.offer?.id]"
                [displayData]="data?.offer?.name"
                [relationData]="data?.offer?.id"
                [rbacProperty]="RbacPermissionsConstant.WIDGETS_OFFER_PROFILE"
              >
              </gtd-ui-field-default-link>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="key"><span i18n="@@common.pixel">Pixel</span>:</span>
            <span class="value">
              <gtd-ui-field-default-string-whitespace-or-empty-with-copy [data]="data.pixel" [tooltipText]="data.pixel | htmlToString">
              </gtd-ui-field-default-string-whitespace-or-empty-with-copy>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="key"><span i18n="@@common.postback">Postback</span>:</span>
            <span class="value">
              <gtd-ui-field-default-string-whitespace-or-empty-with-copy [data]="data.postback">
              </gtd-ui-field-default-string-whitespace-or-empty-with-copy>
            </span>
          </p>
        </li>
        <li>
          <p class="d-flex align-items-center">
            <span class="key"><span i18n="@@common.activity">Activity</span>:</span>
            <span class="value">
              <gtd-ui-field-default-boolean [data]="data.is_active"></gtd-ui-field-default-boolean>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="key"><span i18n="@@common.goal_type">Goal Type</span>:</span>
            <span class="value">
              <gtd-ui-field-default-string-or-empty [data]="data?.goal_type?.name"> </gtd-ui-field-default-string-or-empty>
            </span>
          </p>
        </li>
        <li>
          <p class="d-flex align-items-center">
            <span class="key"><span i18n="@@common.overwrite_from_postback">Overwrite From Postback</span>:</span>
            <span class="value">
              <gtd-ui-field-default-boolean [data]="data.enable_extra_payout"></gtd-ui-field-default-boolean>
            </span>
          </p>
        </li>
        <li>
          <p class="d-flex align-items-center">
            <span class="key"><span i18n="@@common.hide_from_affiliates">Hide From Affiliates</span>:</span>
            <span class="value">
              <gtd-ui-field-default-boolean [data]="data.hide_from_affiliates"></gtd-ui-field-default-boolean>
            </span>
          </p>
        </li>
      </ul>
      <ul>
        <li class="title" i18n="@@common.timestamps">Timestamps</li>
        <li>
          <p>
            <span class="key" i18n="@@common.createdAt">Created At:</span>
            <span class="value">
              <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="key" i18n="@@common.updatedAt">Updated At:</span>
            <span class="value">
              <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
            </span>
          </p>
        </li>
      </ul>
    </div>
  </ng-container>
</gtd-widgets-info-layout>
